import React from "react";
import logo from "../../footer_logo_520x.webp"; // Asegúrate de ajustar la ruta si es necesario
import "./Sidebar.css";

function Sidebar() {
    return (
        <div className="sidebar">
            <div className="sidebar-header">
                <img src={logo} alt="Logo" className="sidebar-logo" />
                <h1 className="sidebar-title">Pedidos no preparados</h1>
                <div style={{display:"flex", gap: "12px"}}>
                <a className={"button"} href={"https://buddha.4sens.io"}>APP B2C</a>
                <a className={"button"} href={"https://buddha-b2b.4sens.io"}>APP B2B</a>
                </div>
            </div>
        </div>
    );
}

export default Sidebar;